
























































































































import {
  defineComponent, ref, computed, onMounted, watch, nextTick,
  PropType,
} from '@vue/composition-api';

import OcrHeader from '@/widgets/ocr-identity/components/ocr-header/index.vue';
import IdentityCard from '@/widgets/ocr-identity/components/identity-card/index.vue';
import UploadBtn from '@/widgets/ocr-identity/components/upload-btn/index.vue';
import UserInfoForm from '@/widgets/ocr-identity/components/user-info-form/index.vue';
import UploadChangeDialog from '@/widgets/ocr-identity/components/upload-change-dialog/index.vue';
import DelCheckDialog from '@/widgets/ocr-identity/components/del-check-dialog/index.vue';
import FindCardTips from '@/components/find-card-tips';
import ButtonBar from '@/components/button-bar';

import BioApi from '@/api/bio';
import { openContract } from '@/ContractConfig';
import { BioAuthPo } from '@/po/bioAuth';
import platform from '@/shared/utils/platform';
import {
  TC_OCR_AGGREMENT,
  TC_OCR_CAMERA,
  TC_OCR_ALBUM,
  TQ_OCR_SUBMIT,
  TE_OCR_DELETE_POPUP,
  TE_OCR_EXCHANGE_POPUP,
} from '@/shared/tools/ocr/tianqi/scan';
import {
  TE_OCR_SOURCE,
  ubtButtonNewOcr,
  ubtExposeNewOcr,
  TE_OCR_ENTER_MSG_SOURCE,
} from '@/shared/tools/ocr/tianqi';
import {
  OCRModeEnum, UploadTypeEnum, UploadProcessTypeEnum, OCRDataSourceTypeEnum,
  OcrProcessSourceEnum, OcrOperationSourceEnum,
} from '@/shared/tools/ocr/enum';
import {
  CardUploadStatusEnum, PageStatusEnum,
} from '@/widgets/ocr-identity/enums';
import { getOcrMsgSource } from '@/shared/verify-credit-controller/utils';
import { session } from '@/shared/utils/storage';
import { getPresentationConfig } from '@/shared/verify-credit-controller';
import { VerifyStageEnum } from '@/shared/verify-credit-controller/types';
import { onOCRUpload, deleteIdentityCard } from './utils/ocrUpload';
import { MaskDataType, OCRIdentityType, TipMsgType } from './types';
import { ID_CARD_AUTH_PROTOCOL } from './constant';

export default defineComponent({
  name: 'OcrIdentity',
  props: {
    showLastStep: {
      type: Boolean,
      default: false,
    },
    showSave: {
      type: Boolean,
      default: false,
    },
    processSource: {
      type: Number as PropType<OcrProcessSourceEnum>,
      default: OcrProcessSourceEnum.OTHER,
    },
    operationSource: {
      type: String as PropType<OcrOperationSourceEnum>,
      default: OcrOperationSourceEnum.GENERAL,
    },
    ocrAfter: {
      type: Boolean,
      default: false,
    },
    ocrAfterLoan: {
      type: Boolean,
      default: false,
    },
    isLoanProcess: {
      type: Boolean,
      default: false,
    },
    processIsLastVerify: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['cancel', 'resolveProcessVerify'],
  components: {
    OcrHeader,
    IdentityCard,
    UploadBtn,
    UserInfoForm,
    FindCardTips,
    ButtonBar,
    UploadChangeDialog,
    DelCheckDialog,
  },
  setup(props, context) {
    const formRef = ref();
    /**  是否已获取用户信息 */
    const isGetUserInfo = ref(false);
    /** 顶部提示信息 */
    const tipMsg = ref<TipMsgType>({});
    /** 页面状态 */
    const pageStatus = ref(PageStatusEnum.INIT);
    /** 上传类型 */
    const uploadType = ref(UploadTypeEnum.SDKCamera);
    /** 人像面上传状态 */
    const frontStatus = ref(CardUploadStatusEnum.PENDING);
    /** 国徽面上传状态 */
    const backStatus = ref(CardUploadStatusEnum.PENDING);
    /** 用户身份信息 */
    const identity = ref<OCRIdentityType>({});
    /** 脱敏前信息（含脱敏状态） */
    const maskData = ref<MaskDataType>({});
    const operateCardType = ref(OCRModeEnum.FRONT);
    const pageHeight = ref(document.body.clientHeight);
    /** 人像面上传成功 */
    const isFrontSuccess = computed(() => frontStatus.value === CardUploadStatusEnum.SUCCESS);
    /** 国徽面上传成功 */
    const isBackSuccess = computed(() => backStatus.value === CardUploadStatusEnum.SUCCESS);
    /** 双面成功 */
    const isBothSuccess = computed(() => isFrontSuccess.value && isBackSuccess.value);
    /**
     * 展示吸底按钮
     * 双面上传成功 ｜展示上一步
     */
    const showBottomBtn = computed(() => isBothSuccess.value || props.showLastStep);

    /** 是否有用户信息
     * 有姓名、身份证、有效期任意一个
     */
    const hadUserInfo = computed(() => (identity.value
      ? !!(identity.value.userName || identity.value.idCardNo || identity.value.periodBegin)
      : false));
    /** 是否展示表单
     * 1. 初始化 && 有用户信息
     * 2. 双面成功
     */
    const showForm = computed((
    ) => (pageStatus.value === PageStatusEnum.INIT && hadUserInfo.value) || isBothSuccess.value);
    /** 是否展示 - 身份证查询引导弹窗 */
    const showFindCardPopup = ref(false);
    /** 是否展示 - 拍摄、相册切换弹窗 */
    const showUploadChangeDialog = ref(false);
    /** 是否展示 - 删除照片弹窗 */
    const showDelCheckDialog = ref(false);
    /** 提交按钮文案 */
    const submitText = computed(() => {
      const presentationConfig = getPresentationConfig()[VerifyStageEnum.ID_CARD];

      if (presentationConfig && presentationConfig.submitText) {
        return presentationConfig.submitText;
      }

      if (props.showSave) {
        return '保存';
      }

      return props.processIsLastVerify ? '提交申请' : `下一步${props.ocrAfterLoan ? '' : ' 人脸验证'}`;
    });

    /** 下一步按钮曝光 */
    watch(showBottomBtn, (value, oldValue) => {
      if (value !== oldValue && showBottomBtn.value) {
        ubtExposeNewOcr(TQ_OCR_SUBMIT, {
          mode: uploadType.value,
          msgSource: session.get('ocrMsgSource'),
          scene: props.processSource,
        });
      }
    });

    const getPageHeight = () => {
      const identityContainer = document.querySelector('.js-verify-credit');
      const noticeBar = document.querySelector('.js-verify-creadit-header');

      let height = document.body.clientHeight;

      if (identityContainer) {
        height = identityContainer.clientHeight || 0;
      }

      if (noticeBar) {
        height -= noticeBar.clientHeight || 0;
      }

      return height;
    };

    /** 点击 - 上一步 */
    const onBackStep = () => {
      context.emit('cancel');
    };

    /** 表单提交成功回调 */
    const onResolveProcessVerify = () => {
      context.emit('resolveProcessVerify', {
        mode: uploadType.value,
      });
    };

    /** 点击 - 下一步/保存
     *  条件：双面成功才可点击下一步
     */
    const onSubmitButtonClick = () => {
      if (formRef.value && isBothSuccess.value) {
        ubtButtonNewOcr(TQ_OCR_SUBMIT, {
          mode: uploadType.value,
          msgSource: session.get('ocrMsgSource'),
          scene: props.processSource,
        });

        formRef.value.submitForm();
      }
    };

    /** 相册、拍摄切换时需重置数据 - 以便保证正反面上传方式一致 */
    const resetData = () => {
      frontStatus.value = CardUploadStatusEnum.PENDING;
      backStatus.value = CardUploadStatusEnum.PENDING;
      pageStatus.value = PageStatusEnum.INIT;
      identity.value = {};
      maskData.value = {};
      tipMsg.value = {
        title: '',
        subTitle: '',
      };
    };

    /** 跳转协议背景：腾讯OCR拍摄需阅读该协议 */
    const goProtocol = () => {
      ubtButtonNewOcr(TC_OCR_AGGREMENT);

      openContract({
        url: ID_CARD_AUTH_PROTOCOL,
        name: '《个人信息授权协议》',
        isThirdUrl: true,
      });
    };

    /** 点击 - 删除照片弹窗 确认按钮 */
    const onDelConfirm = (mode: OCRModeEnum) => {
      identity.value = deleteIdentityCard(mode, identity.value);
      const subTitle = `请重新${uploadType.value === UploadTypeEnum.SDKCamera ? '拍摄' : '上传'}或尝试其他方式`;
      if (mode === OCRModeEnum.FRONT) {
        frontStatus.value = CardUploadStatusEnum.DELETE;
        tipMsg.value = {
          title: isBackSuccess.value ? '人像面识别失败！' : '识别失败！',
          subTitle,
        };
        // 删除后需清除 脱敏信息
        maskData.value.shouldMaskUserName = false;
        maskData.value.shouldMaskIdCardNo = false;
      } else {
        backStatus.value = CardUploadStatusEnum.DELETE;
        tipMsg.value = {
          title: isFrontSuccess.value ? '国徽面识别失败！' : '识别失败！',
          subTitle,
        };
      }
      showDelCheckDialog.value = false;
    };

    /** 点击 - 删除按钮 */
    const onDelete = (cardType: OCRModeEnum) => {
      pageStatus.value = PageStatusEnum.PENDING;
      operateCardType.value = cardType;
      showDelCheckDialog.value = true;

      ubtExposeNewOcr(TE_OCR_DELETE_POPUP);
    };

    /** 点击 - 上传按钮（拍摄/相册上传） */
    const onUpload = async () => {
      if (uploadType.value === UploadTypeEnum.SDKCamera) {
        ubtButtonNewOcr(TC_OCR_CAMERA);
      }

      if (uploadType.value === UploadTypeEnum.Album) {
        ubtButtonNewOcr(TC_OCR_ALBUM);
      }

      const {
        tipMsg: tipMsgRes,
        identity: identityeRes,
        frontStatus: frontStatusRes,
        backStatus: backStatusRes,
        isRemoveMask = false,
      } = await onOCRUpload({
        uploadType: uploadType.value,
        frontStatus: frontStatus.value,
        backStatus: backStatus.value,
        isFrontSuccess: isFrontSuccess.value,
        isBackSuccess: isBackSuccess.value,
        processSource: props.processSource,
        operationSource: props.operationSource,
      });
      pageStatus.value = PageStatusEnum.PENDING;
      if (isRemoveMask) maskData.value = {};// 上传正面成功时清空脱敏信息
      // 注：相册没传：错误信息不变
      if (tipMsgRes) {
        tipMsg.value = tipMsgRes;
      }
      /** 失败或没传，没信息返回时不传
       * 如需新增字端需要更新ID_CARD_FRONT、ID_CARD_BACK
       * * */
      if (identityeRes) {
        identity.value = { ...(identity.value || {}), ...identityeRes };
      }
      if (frontStatusRes) {
        frontStatus.value = frontStatusRes;
      }
      if (backStatusRes) {
        backStatus.value = backStatusRes;
      }
    };

    /** 是否在上传流程中 */
    let isUploadProgress = false;
    /** 点击上传，禁止重复点击 */
    const onUploadNotRepeat = async () => {
      if (isUploadProgress) return;

      // 兼容处理，IOS相册模式不做防重点击，因为取消无回调
      if (!(platform.isIOS && uploadType.value === UploadTypeEnum.Album)) {
        isUploadProgress = true;
      }

      try {
        await onUpload();
      } finally {
        isUploadProgress = false;
      }
    };

    const onChangeUploadType = () => {
      if (isUploadProgress) return;

      showUploadChangeDialog.value = true;

      ubtExposeNewOcr(TE_OCR_EXCHANGE_POPUP);
    };

    /** 点击 - 拍摄、相册切换 确认按钮 */
    const onChangeUploadTypeConfirm = () => {
      showUploadChangeDialog.value = false;
      uploadType.value = uploadType.value === UploadTypeEnum.SDKCamera
        ? UploadTypeEnum.Album : UploadTypeEnum.SDKCamera;
      resetData();
      onUploadNotRepeat();
    };

    /** 获取用户身份证信息 */
    const getIdentity = async () => {
      const res = await BioApi.getIdentity(true, props.processSource) || {};

      const { ocrDataType } = res;
      ubtExposeNewOcr(TE_OCR_SOURCE, {
        ocrDataType,
        processType: UploadProcessTypeEnum.SCAN,
      });

      const identityInfo = res.userInfo as BioAuthPo.Result;
      const msgSource = getOcrMsgSource(identityInfo);

      ubtExposeNewOcr(TE_OCR_ENTER_MSG_SOURCE, {
        msgSource,
        scene: props.processSource,
      });

      session.set('ocrMsgSource', msgSource);

      const {
        userName,
        idCardNo,
        idCardFrontUrl,
        idCardBackUrl,
        uploadType: uploadTypeRes = UploadTypeEnum.SDKCamera,
      } = identityInfo || {};
      maskData.value = {
        defaultUserName: userName || '',
        shouldMaskUserName: !!userName,
        defaultIdCardNo: idCardNo || '',
        shouldMaskIdCardNo: !!idCardNo,
      };
      frontStatus.value = idCardFrontUrl
        ? CardUploadStatusEnum.SUCCESS : CardUploadStatusEnum.PENDING;
      backStatus.value = idCardBackUrl
        ? CardUploadStatusEnum.SUCCESS : CardUploadStatusEnum.PENDING;
      identity.value = identityInfo;
      /** 未区别于之前的拍摄上传，新流程拍摄上传方式需重置为sdkCamera */
      uploadType.value = uploadTypeRes === UploadTypeEnum.Camera
        ? UploadTypeEnum.SDKCamera
        : uploadTypeRes;
    };

    onMounted(async () => {
      try {
        await getIdentity();

        nextTick(() => {
          pageHeight.value = getPageHeight();
        });
      } finally {
        isGetUserInfo.value = true;
      }
    });

    return {
      pageHeight,
      formRef,
      tipMsg,
      uploadType,
      pageStatus,
      frontStatus,
      backStatus,
      identity,
      operateCardType,
      isBothSuccess,
      OCRModeEnum,
      showBottomBtn,
      showForm,
      showFindCardPopup,
      showUploadChangeDialog,
      showDelCheckDialog,
      maskData,
      isGetUserInfo,

      onBackStep,
      onSubmitButtonClick,
      onChangeUploadType,
      onChangeUploadTypeConfirm,
      onDelConfirm,
      onDelete,
      onUploadNotRepeat,
      onResolveProcessVerify,
      goProtocol,
      submitText,
    };
  },
});
